import { CONVERSATIONS_PANEL_WIDTH } from 'Constants/localstorage';

/**
 * Builds the per-user `localStorage` key for the conversations panel width.
 */
export const buildConversationsPanelWidthKey = (userId: number) =>
  `user-${userId}:${CONVERSATIONS_PANEL_WIDTH}`;
